export default __webpack_public_path__ + "static/media/peach2.64a09f2c.png";